import { render, staticRenderFns } from "./FeaturedCarousel.vue?vue&type=template&id=06ed18bc&scoped=true&"
import script from "./FeaturedCarousel.vue?vue&type=script&lang=js&"
export * from "./FeaturedCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCarousel.vue?vue&type=style&index=0&id=06ed18bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ed18bc",
  null
  
)

export default component.exports